import { Search } from "lucide-react";

export function SearchPage() {
  return (
    <section className="view workspace-empty-view" aria-label="搜索">
      <div className="workspace-empty-panel">
        <span className="workspace-empty-icon" aria-hidden="true">
          <Search size={22} />
        </span>
        <h2>搜索</h2>
        <p>搜索页边界已就绪，真实检索能力将在后续任务中接入。</p>
      </div>
    </section>
  );
}
